import { HighlightedBannerSection, type BannerData } from '@components/display/banners';
import { APP_PREFIX_PATH } from '@constants/common';
import { useLazyGetPublicNewsQuery } from '@news/services';
import { handleError } from '@utils/common';
import { useCallback } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

export const HighlightedNews = () => {
    const intl = useIntl();
    const [getNews] = useLazyGetPublicNewsQuery();

    const fetchPage = useCallback(
        async (page: number, pageSize: number) => {
            const response = await getNews({
                page,
                page_size: pageSize,
                highlighted: true,
                requestCache: 'no-store',
            }).unwrap();

            return {
                count: response.count,
                results: response.results.map(
                    (news): BannerData => ({
                        background: 'blue',
                        button_link: `${APP_PREFIX_PATH}/news/${news.id}`,
                        button_text: <FormattedMessage id="news.read_more" defaultMessage="Read more" />,
                        header_text: news.summary || '',
                        header_title: news.title || '',
                        image: news.picture || '',
                        image_alt: news.title || '',
                        loading: false,
                        draft: !news.published,
                    })
                ),
            };
        },
        [getNews]
    );

    const onError = useCallback(
        (error: unknown) => {
            console.error('Error fetching highlighted news:', error);
            handleError(
                intl.formatMessage({ id: 'news.fetch.error', defaultMessage: 'Error fetching highlighted news' }),
                error
            );
        },
        [intl]
    );

    return (
        <HighlightedBannerSection
            fetchPage={fetchPage}
            onError={onError}
            className="pt-6"
            buttonPropsForBanner={(banner) => ({
                component: Link,
                to: banner?.button_link || '',
            })}
        />
    );
};
